/**
 * Test ids and i18n keys for owner viewing slot discoverability (PR #256).
 */

export const OWNER_INCOMING_BOOKING_SECTION_TEST_ID = 'owner-incoming-booking-requests';
export const OWNER_INQUIRY_CARD_TEST_ID_PREFIX = 'owner-inquiry-card-';
export const OFFER_VIEWING_DATES_SECTION_TEST_ID = 'offer-viewing-dates-section';
export const ADD_VIEWING_SLOT_BTN_TEST_ID = 'add-viewing-slot-btn';

export function ownerInquiryCardTestId(inquiryId) {
  return `${OWNER_INQUIRY_CARD_TEST_ID_PREFIX}${inquiryId}`;
}

export const OWNER_VIEWING_DISCOVERABILITY_KEYS = {
  incomingSection: 'owner.incoming_booking_requests',
  incomingSectionHint: 'owner.incoming_booking_section_hint',
  offerTitle: 'owner.viewing_offer_title',
  offerSubtitle: 'owner.viewing_offer_subtitle',
  offerHelper: 'owner.viewing_offer_helper',
  addSlot: 'owner.viewing_add_slot',
  emptyInquiriesTitle: 'owner.incoming_booking_empty_title',
  emptyInquiriesDesc: 'owner.incoming_booking_empty_desc',
  myBookingsOwnerBanner: 'booking.owner_guest_page_banner',
};
